import React from "react";
import RandomButton from "./RandomButton";
import './App.css';

class SearchInputField extends React.Component {
  handleChange = (event) => {
    // Handle input change if needed
    this.props.onChange(event);
  };
  
  handleBlur = (event) => {
    this.props.onBlur();
  }

    render() {
      var placeholderText = "Site not fully online yet, please wait...";
      var _readOnly = true;
      if (this.props.siteStatus === "Up")
      {
        placeholderText = "Search...";
        _readOnly = false;
      };
      return (
        <div className="search-input-container">
          <input  className="input-text-style search-input-text-size"
                  type="text"
                  placeholder={placeholderText}
                  value={this.props.searchValue}
                  onChange={this.handleChange}
                  onBlur={this.handleBlur}
                  readOnly={_readOnly} />
          <RandomButton onClick={this.props.onRandomButtonClick}
                        onBlur={this.handleBlur}
                        disabled={this.props.siteStatus !== "Up"} />
        </div>
    );
  }
}

export default SearchInputField;